import { useTranslation } from 'react-i18next'
import type { ReviewNoteSourceLessonView, ReviewNoteSourceMode } from '@/api/lcReviewNote'
import { getReviewNoteSourceCounts } from '@/utils/reviewNoteSources'

interface Props {
  lessons: ReviewNoteSourceLessonView[]
  totalCount?: number
  sourceMode?: ReviewNoteSourceMode
}

export function ReviewNoteSourceSummary({ lessons, totalCount, sourceMode }: Props) {
  const { t } = useTranslation('coaching')
  const counts = getReviewNoteSourceCounts(lessons)
  if (counts.lessonCount === 0) return null
  return (
    <div className="flex min-w-0 flex-col gap-1 break-words text-sm" aria-label={t('reviewNote.rangeSummaryLabel')}>
      <p className="font-medium tabular-nums">
        {counts.chapterCount > 0 ? t('reviewNote.rangeSummary', counts) : t('reviewNote.legacyRangeSummary', counts)}
        {totalCount != null ? ` · ${t('reviewNote.rangeQuestionCount', {
          source: sourceMode == null ? '' : t(`reviewNote.source.${sourceMode}`),
          count: totalCount,
        })}` : null}
      </p>
      <details className="text-xs text-muted-foreground">
        <summary className="cursor-pointer rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">{t('reviewNote.rangeDetails')}</summary>
        <div className="mt-2 flex max-h-40 flex-col gap-1 overflow-y-auto">
          {lessons.map((lesson) => (
            <p key={lesson.lessonId}>{[lesson.curriculumTitle, lesson.courseTitle, lesson.chapterTitle, lesson.lessonTitle].filter(Boolean).join(' / ')}</p>
          ))}
        </div>
      </details>
    </div>
  )
}
